import {
    addNewRowToTable,
    convertCurrencyFormat, convertUniversalDateToPersianDate, DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoCustomTable, RaikoDatePicker, RaikoDefaultDialogPage,
    RaikoGridOneColumn, RaikoTableSearchContainer, RaikoTableTitleContainer, showServerErrorMessage,
    RaikoCustomSimpleChip,
    RaikoChipTypes, raikoCustomSelectItemGenerator, RaikoCustomSelect, showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {RouteHelper} from "../../route/RouteHelper";
import {useEffect, useState} from "react";
import {useRef} from "react";
import useDraggableScroll from "use-draggable-scroll";
import PointsStatistics from "../../raicheComponents/statistics/PointsStatistics";
import {CostAndRevenueService} from "../../serverService/costAndRevenueService/CostAndRevenueService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useAuthState} from "../../context/AuthContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {useDebounce} from "@uidotdev/usehooks";
import React from "react";
import {TagService} from "../../serverService/tagService/TagService";
import {CategoryService} from "../../serverService/categoryService/CategoryService";
import AddNewCashTransaction from "./AddNewCashTransaction";
import {MagazineCategoryParser} from "../magazineCategory/MagazineCategoryParser";
import {useNavigate} from "react-router-dom";
import {convertCurrencyFormatPositiveNegative} from "../../util/numberConvertor";

export default function CashTransactions() {
    let page = 0
    const size = 20
    const ref = useRef(null);
    const {onMouseDown} = useDraggableScroll(ref, {direction: 'horizontal'});
    const [numberOfItems, setNumberOfItems] = useState("");
    const [summationOfCosts, setSummationOfCosts] = useState(0);
    const [summationOfRevenues, setSummationOfRevenues] = useState(0);
    const [summationOfCommissions, setSummationOfCommissions] = useState(0);
    const [pageCount, setPageCount] = useState(0);

    const [name, setName] = useState("");
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("");
    const [cashTransactionList, setCashTransactionList] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [summation, setSummation] = useState(0);
    const [kind, setKind] = useState(transactionTypeStatus.ALL.id);
    const [tagList, setTagList] = useState([]);
    const [tagSelectedID, setTagSelectedID] = useState(-1);
    const [categoryInlineItems, setCategoryInlineItems] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState(-1)


    const _NameFilter = useDebounce(name, 500);
    const _StartDateFilter = useDebounce(startDate, 500);
    const _endDateFilter = useDebounce(endDate, 500)
    const _tagFilter = useDebounce(tagSelectedID, 500)
    const _categoryFilter = useDebounce(selectedCategoryId, 500)
    const _kindFilter = useDebounce(kind, 500)

    const {fundID} = useAuthState()

    const service = new CostAndRevenueService();
    const tagService = new TagService();
    const categoryService = new CategoryService();

    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        getTagListFromServer()
        getCategoryListFromServer()
        getReportsFromServer()
    }, [fundID]);

    useEffect(() => {
            if (typeof service !== 'undefined') {
                getCashTransactionDataFromServer()
            }
        },
        [
            _NameFilter,
            _StartDateFilter,
            _endDateFilter,
            _tagFilter,
            _categoryFilter,
            _kindFilter,
            fundID
        ]
    )

    function getTagListFromServer() {

        tagService.getTagList(fundID, 0, 1000000).then(
            response => {

                setTagList([])
                response.data.map((item) => {
                    setTagList(prevState => [...prevState,
                        raikoCustomSelectItemGenerator(item.id, item.name)
                    ])
                })
                console.log("tag list", tagList)
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        })
    }

    function getCategoryListFromServer() {
        categoryService.getCategoryList(fundID).then(
            response => {
                const categoryParser = new MagazineCategoryParser(response)
                setCategoryInlineItems(categoryParser.getCategoryListInlineParser())
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        })
    }

    function getReportsFromServer() {
        loading.show()
        service.getCashTransactionsReport(fundID).then(
            response => {
                setSummationOfCosts(response.summationOfCosts)
                setSummationOfRevenues(response.summationOfRevenues)
                setSummationOfCommissions(response.summationOfCommissions)
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function tablePreparation(
        id,
        number,
        title,
        kind,
        tag,
        categories,
        amount,
        createdAt,
        enabled,
    ) {

        return {
            id: id,
            number: number,
            title: title,
            transactionType: kind === "REVENUES" ?
                <RaikoCustomSimpleChip title={"درآمد"} type={RaikoChipTypes.success}/>
                : <RaikoCustomSimpleChip title={"هزینه"} type={RaikoChipTypes.error}/>,
            tag: tag,
            transactionAmount: convertCurrencyFormat(amount),
            date: convertUniversalDateToPersianDate(createdAt),
            enabled: enabled === true ?
                <RaikoCustomSimpleChip title={"فعال"} type={RaikoChipTypes.success}/>
                : <RaikoCustomSimpleChip title={"غیر فعال"} type={RaikoChipTypes.error}/>,
            category: categories && categories.length > 0 ? categories[0].title : "-",
        }
    }

    function getCashTransactionDataFromServer() {
        setTableLoading(true)
        service.getCashTransactionsList(
            fundID,
            page,
            size,
            name,
            startDate,
            endDate,
            tagSelectedID,
            selectedCategoryId,
            kind,
        ).then(
            response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setCashTransactionList([])

                response.data.map((item, index) => {
                    setCashTransactionList(prevState => [
                        ...prevState,
                        tablePreparation(
                            item.id,
                            (page * 20) + index + 1,
                            item.title,
                            item.kind,
                            item.tag ? item.tag.name : "-",
                            item.categories,
                            item.amount,
                            item.payAt,
                            item.enabled,
                        )
                    ])
                })
                setSummation(response.summationOfAmount)
                console.log("here" , response.summationOfAmount)
                setTableLoading(false)
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    //
    const [openAddNewItem, setOpenAddNewItem] = useState(false);

    function handleOpenDialog() {
        setOpenAddNewItem(true)
    }

    function handleCloseDialog() {
        setOpenAddNewItem(false)
    }

    function handleClearAllFields() {
        setStartDate("");
        setEndDate("");
        setKind(transactionTypeStatus.ALL.id)
        setTagSelectedID(-1)
        setSelectedCategoryId(-1)

    }


    const navigate = useNavigate()

    function showCashTransactionDetail(id) {
        let title = ""
        cashTransactionList.map((item) => {
            if (item.id === id) {
                title = item.title
            }
        })
        navigate(RouteHelper.CashTransactionsDetails.globalUrl.replace(":id", id),
            {state: {title: title}, replace: false}
        )

    }

    function handleAddNewItemToTable(item) {
        const newItem = addNewRowToTable(
            tablePreparation(
                item.id,
                (page * size) + 1,
                item.title,
                item.kind,
                item.tag ? item.tag.name : "-",
                item.categories,
                item.amount,
                item.payAt,
                item.enabled,
            ),
            cashTransactionList
        )
        setCashTransactionList(newItem)
        handleCloseDialog()
    }


    function handleChangePage(newPage) {
        page = newPage
        getCashTransactionDataFromServer()
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openAddNewItem}
                dialogSize={DialogSize.MEDIUM}
                pageTitle={"افزودن تراکنش جدید"}
            >
                <AddNewCashTransaction
                    tagList={tagList}
                    categoryList={categoryInlineItems}
                    addNewItemToTable={handleAddNewItemToTable}
                />
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.CostAndRevenue.name,
                            ""
                        ),
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.CashTransactions.name,
                            RouteHelper.CashTransactions.globalUrl
                        )
                    ]}/>
                    <div className="statisticsLayout hideScroll" ref={ref} onMouseDown={onMouseDown}>
                        <PointsStatistics
                            title={"مجموع درآمد ها (ریال)"}
                            amount={summationOfRevenues}
                        />
                        <PointsStatistics
                            title={"مجموع هزینه ها (ریال)"}
                            amount={summationOfCosts}
                        />
                        <PointsStatistics
                            title={"مجموع کمیسیون ها (ریال)"}
                            amount={summationOfCommissions}
                        />

                    </div>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"تراکنشات"}
                                amount={numberOfItems}
                                hasCreateNewItem={true}
                                handleCreateNewItem={handleOpenDialog}
                            />
                            <RaikoTableSearchContainer
                                hasFilter={true}
                                labelText={"عنوان"}
                                placeHolder={"عبارت مورد نظر را وارد نمایید"}
                                value={name}
                                setValue={setName}
                                handleDeleteAllFilters={handleClearAllFields}
                                filterStatus={
                                    name.length > 0 || parseInt(startDate) > 0 ||
                                    parseInt(endDate) > 0 || kind !== transactionTypeStatus.ALL.id ||
                                    parseInt(tagSelectedID) > 0 || parseInt(selectedCategoryId) > 0
                                }
                            >
                                <RaikoGridOneColumn>
                                    <RaikoDatePicker
                                        label={"شروع بازه زمانی"}
                                        date={startDate}
                                        setDate={setStartDate}
                                    />
                                    <RaikoDatePicker
                                        label={"پایان بازه زمانی"}
                                        date={endDate}
                                        setDate={setEndDate}
                                    />
                                    <RaikoCustomSelect
                                        labelText={"نوع تراکنش"}
                                        setValue={setKind}
                                        onChange={e => {
                                            setKind(e.target.value)
                                        }}
                                        items={[
                                            raikoCustomSelectItemGenerator(transactionTypeStatus.ALL.id, transactionTypeStatus.ALL.name),
                                            raikoCustomSelectItemGenerator(transactionTypeStatus.COST.id, transactionTypeStatus.COST.name),
                                            raikoCustomSelectItemGenerator(transactionTypeStatus.REVENUE.id, transactionTypeStatus.REVENUE.name),
                                        ]}
                                        value={kind}
                                    />
                                    <RaikoCustomSelect
                                        labelText={"تگ"}
                                        setValue={setTagSelectedID}
                                        items={
                                            [raikoCustomSelectItemGenerator(-1, "همه"),
                                                ...tagList
                                            ]
                                        }
                                        value={tagSelectedID}
                                    />
                                    <RaikoCustomSelect
                                        labelText={"دسته بندی"}
                                        setValue={setSelectedCategoryId}
                                        items={
                                            [raikoCustomSelectItemGenerator(-1, "همه"),
                                                ...categoryInlineItems
                                            ]
                                        }
                                        value={selectedCategoryId}
                                    />

                                </RaikoGridOneColumn>
                            </RaikoTableSearchContainer>
                            <RaikoCustomTable
                                header={cashTransactionHeader}
                                data={cashTransactionList}
                                isLoading={tableLoading}
                                summationOfAmount={summation}

                                pageCount={pageCount}
                                handlePaginationChange={handleChangePage}
                                currencyUnit={"ریال"}
                                rowClicked={showCashTransactionDetail}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>

                </RaikoGridOneColumn>
            </RaikoBaseContainer>

        </>
    )
}
export const transactionTypeStatus = {
    ALL: {
        id: "ALL",
        name: "همه"
    }, COST: {
        id: "COSTS",
        name: "هزینه"
    }, REVENUE: {
        id: "REVENUES",
        name: "درآمد"
    },
};
const cashTransactionHeader = [
    {
        id: "number",
        label: "#"
    }, {
        id: "title",
        label: "عنوان"
    }, {
        id: "transactionType",
        label: "نوع تراکنش"
    }, {
        id: "tag",
        label: "تگ"
    }, {
        id: "category",
        label: "دسته بندی"
    }, {
        id: "transactionAmount",
        label: "مبلغ (ریال)"
    }, {
        id: "date",
        label: "تاریخ"
    }, {
        id: "enabled",
        label: "وضعیت"
    },
]